import React from 'react'
import '../../scss/datatable-wrapper.scss'
import classNames from 'classnames';

const { MDBDataTable} = require('mdbreact');

export interface DataTableColumnCfg {
    label:string;
    field:string;
    sort:string;
    width: number;
};

interface DataTableProps {
     striped: boolean;
     bordered: boolean;
     hover: boolean;
     hideFooter?: boolean;
     className?:string;
     showEntries?: boolean;
     searching: boolean;
     info: boolean;
     sortable: boolean;
     paging: boolean;

     data: {
         columns:   DataTableColumnCfg[];
         rows: {[key:string]:JSX.Element}[];
     }
}

export class DataTable extends React.Component<DataTableProps,{}> {
    constructor(props:DataTableProps){
        super(props);
    }

    render(){
        let striped = this.props.striped === undefined ? true : this.props.striped;
        let bordered = this.props.bordered === undefined ? true : this.props.bordered;
        let hover = this.props.hover === undefined ? true : this.props.hover;
        let searching = this.props.searching === undefined ? false : this.props.searching;
        let className = this.props.className === undefined ? '' : this.props.className;
        let showEntries = this.props.showEntries === undefined ? true : this.props.showEntries;
        let hideFooter = this.props.hideFooter === undefined ? true : this.props.hideFooter;
        let sortable = this.props.sortable === undefined ? true : this.props.sortable;
        let paging = this.props.paging === undefined ? true: this.props.paging;

        let classes = classNames(
            `${showEntries ? 'show-entries':'hide-entries'}`,
            `${hideFooter ? 'hide-footer':''}`,
            className);

        let dataTableProps = {...this.props};
        delete dataTableProps.showEntries;
        delete dataTableProps.hideFooter;
        delete dataTableProps.className;
        dataTableProps = {...dataTableProps, striped, bordered, hover, searching, sortable, paging };

        return (
            <div className={classes}>
                <MDBDataTable responsive
                              {...dataTableProps}
                />
            </div>
        )
    }
}
